import { render, staticRenderFns } from "./page-no-data-new.vue?vue&type=template&id=54c303ee&scoped=true&"
import script from "./page-no-data-new.vue?vue&type=script&lang=ts&"
export * from "./page-no-data-new.vue?vue&type=script&lang=ts&"
import style0 from "./page-no-data-new.vue?vue&type=style&index=0&id=54c303ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c303ee",
  null
  
)

export default component.exports